import axios                 from "app/services/axios/CustomAxios";
import { apiUrl }            from "app/services/axios/configApi";

export function readAllPbxQueues() {
    return axios(apiUrl + "/services/pbxQueues");
}
export function showPbxQueue(id) {
    return axios(apiUrl + "/services/pbxQueues/" + id);

}export function kickUser(id, extension){
    return axios.post(apiUrl + "/services/pbxQueues/"+id+"/currentUsers/kickUser",  {
        "extension" : extension

    });
}
export function ShowCurrentUsers(id) {
    return axios(apiUrl + "/services/pbxQueues/"+id+"/currentUsers");

}


export function createPbxQueue(pbxQueue) {
    return axios.post(apiUrl + "/services/pbxQueues", {
        "name"        : pbxQueue.name,
        "queue_id": pbxQueue.queue_id,
    })
        .catch(error => {
            return error.response;
        });
}

export function updatePbxQueue(pbxQueue, id) {
    return axios.put(apiUrl + "/services/pbxQueues/" + id, {
        "name"        : pbxQueue.name,
        "queue_id": pbxQueue.queue_id,
    })
        .catch(error => {
            return error.response;
        });
}

export function deletePbxQueue(id) {
    return axios.delete(apiUrl + "/services/pbxQueues/" + id)
        .catch(error => {
            return error.response;
        });
}

export function findCurrentCallCustomer(){
    return axios(apiUrl + "/services/findCurrentCallCustomer");
}
